// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentfulFacebookDecryptionKey_wrapper_sk5pt"};